import type { RouteLocationNormalized } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';

/**
 * 認証ガード (§7)。status が確定するまで待ち、3値で分岐する。
 * Firebase 無効モードは authStore が即 ready になるため素通し (現行動作の温存)。
 *
 * router/index.ts から分離: index.ts は createWebHistory() を呼ぶため window に
 * 依存し、node 環境の単体テストから import できない。authGuard は純粋な関数として
 * ここに置き、index.ts 側から import して beforeEach に登録する。
 */
export async function authGuard(
  to: RouteLocationNormalized,
): Promise<true | { name: 'Login'; query: { reason: string } }> {
  if (to.name === 'Login') return true;
  const auth = useAuthStore();
  if (auth.status === 'loading') await auth.whenSettled();
  // auth.error が立っている (init/evaluateUser が例外で denied に落ちた) 場合は
  // 「利用許可なし」ではなく「エラー」として案内する — allowlist 未登録と
  // ネットワーク断/初期化失敗を混同させないため。
  if (auth.error) return { name: 'Login', query: { reason: 'error' } };
  switch (auth.status) {
    case 'ready':
      return true;
    case 'unverified':
      return { name: 'Login', query: { reason: 'unverified' } };
    case 'denied':
      return { name: 'Login', query: { reason: 'denied' } };
    default:
      return { name: 'Login', query: { reason: 'signin' } };
  }
}
